import { AutoAwesomeOutlined } from '@mui/icons-material';

const AIEnabled = (): JSX.Element => <AutoAwesomeOutlined fontSize="inherit" />;

export default AIEnabled;
